import React, {useEffect, useRef, useState} from "react";

type Props = {
    error: string | undefined;
}

export function FieldError({error}: Props) {
    const [visible, setVisible] = useState(false);
    const [text, setText] = useState(error);
    const frameRef = useRef<number | null>(null);

    useEffect(() => {
        if (error) {
            setText(error);
            // Two-frame delay so the browser renders the collapsed state first
            frameRef.current = requestAnimationFrame(() => {
                frameRef.current = requestAnimationFrame(() => setVisible(true));
            });
        } else {
            setVisible(false);
        }
        return () => { if (frameRef.current) cancelAnimationFrame(frameRef.current); };
    }, [error]);

    return (
        <div
            data-field-error={text ? "" : undefined}
            style={{
                display: "grid",
                gridTemplateRows: visible ? "1fr" : "0fr",
                opacity: visible ? 1 : 0,
                transition: "grid-template-rows 200ms ease 50ms, opacity 200ms ease 50ms",
            }}
        >
            <p className="overflow-hidden text-red text-sm mt-2">
                {text ? text.charAt(0).toUpperCase() + text.slice(1) : ""}
            </p>
        </div>
    );
}
